import { FILE_CONFIG, FILE_KEYS } from "../utils/core";

export interface PreviewableFile {
  name?: string;
  filename?: string;
  url?: string;
  preview?: string;
  contentType?: string;
  type?: string;
  byteSize?: number | string;
  size?: number;
}

export interface FileThumbnailProps {
  file: PreviewableFile;
  className?: string;
  iconClassName?: string;
}

export type FileAccept = Record<string, readonly string[]>;

export type FILE_TYPES = (typeof FILE_KEYS)[keyof typeof FILE_KEYS];

export type FILE_CONFIG_TYPE = (typeof FILE_CONFIG)[keyof typeof FILE_CONFIG];

export const getFileConfig = (file: File | null) => {
  if (!file) return FILE_CONFIG.default;
  const extension = file?.name?.split(".").pop()?.toLowerCase();

  return (
    FILE_CONFIG[extension as keyof typeof FILE_CONFIG] ?? FILE_CONFIG.default
  );
};
